module.exports = __webpack_public_path__ + "img/Scooter Icon - charcoal.3733f0ce.svg";